<template>
    <div>
        <slot
            :error-alert-message="getVerbose('mfa_code_error')"
            :instruction-alert-message="getVerbose('mfa_code_instruction')"
            :mfa-code-input-label="getVerbose('mfa_code_input_label')"
            :mfa-new-code-button="getVerbose('mfa_new_code_button') "
            :error="error"
            :data="formData"
            :connecting="connecting"
            :submit-code="submitCode"
            :send-code-again="sendCodeAgain"
        >
            <el-alert
                v-if="error"
                show-icon
                :title="getVerbose('mfa_code_error')"
                :description="error"
                type="error"
            >
            </el-alert>
            <el-alert
                v-else
                :title="getVerbose('mfa_code_instruction')"
                type="info"
            >
            </el-alert>
            <el-form
                ref="doubleAuthForm"
                :rules="rules"
                :model="formData"
                label-position="top"
                novalidate
                @submit="checkForSubmitCode"
                @keyup.enter.native="checkForSubmitCode"
            >
                <el-form-item
                    :label="getVerbose('mfa_code_input_label')"
                    prop="verificationCode"
                >
                    <el-input
                        v-model="formData.verificationCode"
                        type="number"
                    >
                    </el-input>
                </el-form-item>
                <div class="two-factor-buttons">
                    <el-form-item>
                        <button
                            :disabled="connecting"
                            type="submit"
                            class="el-button el-button--primary"
                            @click="checkForSubmitCode"
                        >
                            <i v-if="connecting" class="el-icon-loading"></i>
                            <span>
                                {{ getVerbose('mfa_submit_button') }}
                            </span>
                        </button>
                    </el-form-item>
                    <div>

                        <el-button
                            :disabled="connecting"
                            type="text"
                            @click="sendCodeAgain"
                        >{{ getVerbose('mfa_new_code_button') }}</el-button>
                    </div>
                </div>
            </el-form>
        </slot>
    </div>
</template>

<script>

import { mapGetters } from 'vuex';
import HttpErrorManager from '../partials/http-error-manager.js';

export default {

    components: {

    },

    props: {
        doubleAuthResponse: {
            type: Object, // provisoire devra repasser à string
            required: true,
        },
        onSuccess: {
            type: Function,
            default(){
                return () => {

                };
            },
            required: false,
        },
    },

    data: function(){
        return {
            formData: {verificationCode: '',},
            connecting: false,
            error: '',
            rules: {
                verificationCode: [
                    {
                        required: true,
                        message: '',
                        trigger: 'blur'
                    },
                ]
            },
        };
    },

    computed: {
        ...mapGetters('fundation', [
            'getVerbose',
        ])
    },

    created() {
        this.rules.verificationCode.message = this.getVerbose('mfa_input_validation_error');
        this.httpErrorManager = new HttpErrorManager();
    },

    mounted: function(){

    },

    methods: {
        checkForSubmitCode (event){
            event.preventDefault();
            if(this.connecting) return;
            this.$refs.doubleAuthForm.validate().then(() => {
                this.submitCode();
            });
        },
        submitCode (){
            this.error = '';
            this.connecting = true;

            let data = {
                email: this.doubleAuthResponse.email,
                token: this.doubleAuthResponse.token,
                verification_code: this.formData.verificationCode,
                user: this.doubleAuthResponse,

            };

            this.$store.dispatch(
                'checkVerificationCode',
                data
            ).then((response) => {
                this.onSuccess(response);
                this.$emit('success', response);
                this.$store.commit('LOGIN_USER', response.data);
                this.$store.dispatch('fetchSelfUser');
                this.$store.dispatch('loadModels').catch(() => {});
            }).catch((error) => {
                console.error('Error while MFA');
                try {
                    this.error = this.httpErrorManager.getMessage(
                        error.status, error.data._errors);
                }
                catch(error) {
                    console.error(error);
                    this.error = 'Unknow error, please contact an administrator.';
                }
                console.error(this.error);
            }).finally(() => {
                this.connecting = false;
            });

        },
        sendCodeAgain (){
            this.$emit('on-reset-double-factor-auth');
        }
    },
};
</script>

<style lang="scss">
    .two-factor-buttons{
        display: flex;
        justify-content: space-between;
        align-items: center;

        .el-form-item{
            margin-bottom: 0;
        }
    }

    .notification-patch{
        z-index: 999999999999999999999999 !important;
    }
</style>



// WEBPACK FOOTER //
// node_modules/fundation-app-vuejs/src/components/auth/TwoFactorAuth.vue